<div [class]="'notification-snack ' + data.type">
  <div class="msg-container">{{data?.msg}}</div>
  <div class="button-container">
    <button (click)="snackRef?.dismiss()">OK</button>
  </div>
</div>